export const HowItWorksMocks = {
  title: 'How It Works?',
  description:
    '<div><p><strong>Biofreeze relieves pain in 3 steps using the gate control theory <sup>2,4</sup></strong></p><p><strong>Step 1:</strong> Biofreeze activates specific cold receptors in the skin and leads to localised cooling through evaporation of key ingredients from the skin<sup>2</sup></p><p><strong>Step 2:</strong> Cooling Biofreeze overrides pain signals to the brain<sup>2</sup></p><p><strong>Step 3:</strong> The cooling effect is perceived over the pain sensation, helping with pain relief<sup>2</sup></p></div>',
  linkText: 'See all products',
  link: '/products/',
  image: {
    mobile: {
      src: 'https://eu-images.contentstack.com/v3/assets/bltcec956bfb728201c/blt59299ab7a3af8451/68540961b6a81e1868b4a8c0/How_it_works_mob.png',
      alt: 'How It Works',
    },
    desktop: {
      src: 'https://eu-images.contentstack.com/v3/assets/bltcec956bfb728201c/bltd6519748cd3fa397/6853bd9e0c9b7e861f1435da/How_it_works_des.png',
      alt: 'How It Works',
    },
  },
  imageTextTop:
    '<p><span>Pain signals</span> become<br/>blocked before reaching<br/>the brains</p>',
  imageTextBottom:
    '<p>Biofreeze produces<br/><span>a cold sensation</span><br/>overriding the pain signals</p>',
  imageNote:
    '1. Melzack, R, Wall, P. Pain Mechanisms: A New Theory. Science, Vol. 150, 1965, 971-979.<br/>2. Page, P, Alexander, L. The clinical effectiveness of Biofreeze topical analgesic on musculoskeletal pain: a systemic review. J Perform Health Res. 2017, 1:1-10.',
};

export const HowItWorksOthersMocks = {
  ...HowItWorksMocks,
  linkText: 'Learn more about our product',
  link: '/how-it-works/',
  description:'<ul><li>Nerve cells regulate our perception of pain by carrying information from receptors found in the skin and throughout the body, to the spinal cord, before being sent to the brain for processing. The brain then interprets these signals, and the body reacts to these stimuli in the form of pain.<sup>1</sup></li><li>However, the scientifically proven cooling formula of Biofreeze provides cold sensations that override the pain signals to the brain, providing body pain relief.<sup>2</sup></li></ul>',
};

export const HowItWorksProductsMocks = {
  ...HowItWorksMocks,
  description:'<ul><li>Pain happens when your receptors found in the skin send a signal throughout the body, to the spinal cord before being sent to your brain. Cold sensations stimulate receptors to override those signals to relieve pain according to the gate control theory.</li> <li>The fast acting*, scientifically proven cooling formula of Biofreeze provides a long-lasting sensation on application, helping to ease your pain.<p>&nbsp;</p><p><sup>*not linked to pain relief</sup><br><sup>†refers to cooling</p></li></ul>',
  link: '/how-it-works/',
  linkText:'Learn more about our formula',
}